import { styled } from "theme/default/styled";

export const SSignInSendButtonLoader = styled.div`
  margin-top: 10px;
`;
